import {
  Directive,
  Input,
  OnChanges,
  SimpleChanges,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';

import { PermissionsService } from '../permissions.service';

/**
 * @example
 * <elemento *allowed="'permission'"/>
 *
 * @description funciona como um *ngIf porém usa as permissoes como base mas so mostra o item se existir ao menos uma permissão da lista
 */

@Directive({
  selector: '[displayAllowed]',
  standalone: true,
})
export class DisplayAllowedDirective implements OnChanges {
  @Input() displayAllowed: string | string[] = '';

  constructor(
    private readonly _templateRef: TemplateRef<any>,
    private readonly _viewContainer: ViewContainerRef,
    private readonly _permissionsService: PermissionsService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (typeof this.displayAllowed === 'string') {
      this.handlePermissionString();
    } else {
      this.handlePermissionArray();
    }
  }

  handlePermissionString(): void {
    let isAllowed: boolean = this._permissionsService.checkHavePermissions(
      this.displayAllowed.toString()
    );

    this.handleEmbeddedView(isAllowed);
  }

  handlePermissionArray(): void {
    let allowed: string[] = [...this.displayAllowed];
    let isAllowed: boolean = allowed.some((per) =>
      this._permissionsService.checkHavePermissions(per)
    );

    this.handleEmbeddedView(isAllowed);
  }

  handleEmbeddedView(isAllowed: boolean): void {
    if (isAllowed) {
      this._viewContainer.createEmbeddedView(this._templateRef);
    } else {
      this._viewContainer.clear();
    }
  }
}
